import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faStar, faQrcode, faTools,  faBriefcaseMedical, 
  faIdCard, faChartPie, faStethoscope, faHeartbeat,
  faClock, faRunning, faTint, faThermometerHalf, 
  faLungs, faWeight, faCapsules, faPills, faBed, 
  faDeaf, faLungsVirus, faHeartPulse, faSyncAlt,
  faBaby,
  faBolt,
  faEarth,
  faListDots,
  faBuilding,
  faCow,
  faPlane,
  faBus,
  faTaxi,
  faMotorcycle,
  faHotel,
  faSuitcaseRolling,
  faCalendarCheck,
  faCalendarAlt,
  faTag,
  faCar
} from '@fortawesome/free-solid-svg-icons';
import './ThinkTravel.css';
import thinktravelimage from '../../assets/pageimages/ThinkTravel.webp';

function ThinkTravelHome() {

  const LinkButton = ({ to, icon, label }) => (
    <div className="flex justify-center">
      <Link
        to={to}
        className="flex items-center flex-wrap justify-center p-3 w-full bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-all duration-300"
      >
        <FontAwesomeIcon icon={icon} className="text-xl sm:text-xl mr-3" />
        <span>{label}</span>
      </Link>
    </div>
  );

  const LinkNoButton = ({ to, icon, label }) => (
    <div className="flex justify-center">
      <Link
        to={to}
        className="flex items-center flex-wrap justify-center p-3 w-full bg-gray-200 text-gray-800 font-semibold rounded-lg hover:bg-gray-300 transition-all duration-300"
      >
        <FontAwesomeIcon icon={icon} className="text-xl sm:text-xl mr-3" />
        <span>{label}</span>
      </Link>
    </div>
  );

  return (
    <MainLayout>
      <div className="mt-12 text-sm min-h-screen bg-gradient-to-r from-gray-300 via-blue-300 to-blue-800 flex flex-col items-center py-8">
        <h2 className="text-4xl font-bold text-white text-center mb-4">ThinkTravel</h2>
        <img
          src={thinktravelimage}
          alt="ThinkTravel"
          style={{width:'300px', height: 'auto'}}
          className="w-full h-auto max-w-xs md:max-w-sm lg:max-w-md xl:max-w-lg rounded-lg shadow-md"
        />

        <div className="flex-grow">
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4 p-4 bg-gray-600 rounded-lg shadow-lg transition-transform transform hover:scale-105 mx-4 mt-6">
            <LinkNoButton to="" icon={faPlane} label="Flight" />
            <LinkNoButton to="" icon={faBus} label="Bus" />
            <LinkNoButton to="" icon={faTaxi} label="Taxi" />
            <LinkNoButton to="" icon={faMotorcycle} label="Two Wheeler" />
            <LinkNoButton to="" icon={faHotel} label="Accomodation" />
            <LinkNoButton to="" icon={faSuitcaseRolling} label="Package" />
            <LinkNoButton to="" icon={faTag} label="Offers" />
            <LinkNoButton to="" icon={faCalendarCheck} label="My Bookings" />
            <LinkNoButton to="" icon={faCalendarAlt} label="My Plan" />
            <LinkNoButton to="" icon={faCar} label="List My Vehicle" />
            <LinkNoButton to="" icon={faBed} label="List My Room" />


          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default ThinkTravelHome;
